module.exports = __webpack_public_path__ + "media/images/hero-allcare-banner-2560-db513662186601f6012192565033cd19.webp";